import {
  UserCredential,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateEmail,
  updatePassword,
  User,
  EmailAuthProvider,
  reauthenticateWithCredential,
} from 'firebase/auth';

import UserProfileApi from './userProfileApi';
import UserProfileData from '../types/userProfileData';
import { auth } from '../utils/firebase';

export interface CreateUserCredentials {
  email: string;
  password: string;
  researchConsent: boolean;
}

export default class AuthApi {
  public static async addUser(email: string, password: string): Promise<UserCredential> {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  public static async signin(email: string, password: string): Promise<[User, UserProfileData | null]> {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    const userProfile = await UserProfileApi.getUserProfileByUuid(user.uid);
    return [user, userProfile];
  }

  public static async signOut(): Promise<void> {
    return signOut(auth);
  }

  public static async updateUserEmail(currentUser: User, newPassword: string) {
    updateEmail(currentUser, newPassword);
  }

  public static async updateUserPassword(newPassword: string): Promise<boolean> {
    try {
      if (!auth.currentUser) return false;

      await updatePassword(auth.currentUser, newPassword);
      return true;
    } catch (error) {
      return false;
    }
  }

  public static async reauthenticateUser(password: string): Promise<boolean> {
    try {
      if (!auth.currentUser) return false;
      if (!auth.currentUser.email) return false;

      const credentials = EmailAuthProvider.credential(auth.currentUser.email, password);

      await reauthenticateWithCredential(auth.currentUser, credentials);
      return true;
    } catch (error) {
      return false;
    }
  }
}
